<c-card class="mb-5">

    <c-card-body>


        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="mb-0 border">


                <ng-container matColumnDef="token" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Token Name
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.token}}</td>
                </ng-container>

                <ng-container matColumnDef="name" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Coin Name
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}}</td>
                </ng-container>

                <ng-container matColumnDef="balance" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Balance
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.balance}}</td>
                </ng-container>

                <ng-container matColumnDef="sent" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Sent Amount
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.sent}}</td>
                </ng-container>

                <ng-container matColumnDef="received" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Status
                    </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let element">{{element.received}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'hide-data': isLoading }">
                </tr>
            </table>
            <div *ngIf="isLoading" class="spinner-container">
                <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
                </mat-progress-spinner>
            </div>
        </div>
        <!-- Paginator -->
        <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="pageChanged($event)">
        </mat-paginator>



    </c-card-body>
</c-card>